<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    <table class="table table-bordered form-inline InnerTblBG custom-table">
      <thead>
        <tr class="row">
          <th class="row">
            <p>Line No</p>
          </th>
          <th class="row">
            <p>Line Description</p>
          </th>
          <th class="row">
            <p>CY Generated Amount</p>
          </th>
          <th class="row">
            <p>Adjustment Amount</p>
          </th>
          <th class="row">
            <p>Total CY Generated Amount</p>
          </th>
          <th class="row">
            <p>Comments</p>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of modalData; track itemTracker(i, item); let i = $index) {
<tr class="row">
          <td class="row">
            <p>{{ item.LINE_NO }}</p>
          </td>
          <td class="row">
            <p>{{ item.LINE_DESCRIPTION }}</p>
          </td>
          <td class="row">
            <p>
              <input 
                disabled 
                class="form-control input-md numText number-field" 
                type="text"
                [value]="formatNumber(item.GENERATED_AMT)"
                readonly>
            </p>
          </td>
          <td class="row">
            <p>
              <input 
                class="form-control input-md numText number-field" 
                type="text"
                [value]="formatNumber(item.ADJUSTMENT_AMT)"
                (input)="onAmountInput($event, item, 'ADJUSTMENT_AMT')">
            </p>
          </td>
          <td class="row">
            <p>
              <input 
                disabled 
                class="form-control input-md numText number-field" 
                type="text"
                [value]="formatNumber(item.totalCYAmount)"
                readonly>
            </p>
          </td>
          <td class="row">
            <p>
              <input 
                type="text" 
                class="form-control input-md" 
                [(ngModel)]="item.COMMENTS"
                (ngModelChange)="valueChanged(item, i)">
            </p>
          </td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button  
          class="save-button"  
          type="button"  
          [disabled]="isSaveClicked || disable"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button  
          class="reset-button"  
          type="button"  
          [disabled]="disable"
          (click)="reset()">Reset</button>
}
  <button class="button-cancel"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
